import React, { useEffect } from "react";
import Button from "../Button/Button";
import { ICONS } from "./icons";
import {
  Backdrop,
  ButtonsRow,
  IconWrapper,
  Message,
  ModalCard,
  Title,
} from "./Popup.styles";

const ICON_SIZE = 48;

const renderIcon = (icon) => {
  if (!icon) return null;
  if (React.isValidElement(icon)) return icon;
  const entry = ICONS[icon];
  if (!entry) return null;
  const { Icon, color } = entry;
  return <Icon size={ICON_SIZE} color={color} />;
};

const Popup = ({
  type,
  icon,
  title,
  message,
  confirmText = "ok",
  cancelText = "Cancelar",
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key !== "Escape") return;
      if (type === "confirm") onCancel();
      else onConfirm();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [type, onConfirm, onCancel]);

  // Confirmações destrutivas não fecham por clique fora — exige clique explícito.
  const handleBackdropClick = () => {
    if (type === "alert") onConfirm();
  };

  const resolvedIcon = renderIcon(icon);
  const isDestructive = icon === "delete";
  const confirmVariant = isDestructive ? "danger" : "primary";

  return (
    <Backdrop onClick={handleBackdropClick} role="presentation">
      <ModalCard
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? "popup-title" : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        {resolvedIcon && <IconWrapper>{resolvedIcon}</IconWrapper>}
        {title && <Title id="popup-title">{title}</Title>}
        {message && <Message>{message}</Message>}
        <ButtonsRow>
          {type === "confirm" && (
            <Button variant="ghost" onClick={onCancel}>
              {cancelText}
            </Button>
          )}
          <Button variant={confirmVariant} onClick={onConfirm}>
            {confirmText}
          </Button>
        </ButtonsRow>
      </ModalCard>
    </Backdrop>
  );
};

export default Popup;
